import React, { useEffect, useState, useContext } from "react";
import {
  Row, Col
} from "reactstrap";
import "./OurServicesDetails_components.css"

export function OurServicesDetails_AirconPrice() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Our Aircon Servicing Prices</h2>
          </div>
        </Col>
      </Row>
      <table className="rate-table">
        <tr>
          <th>Base Service</th>
          <th>Price</th>
        </tr>
        <tr>
          <td>Aircon Normal Servicing<br />(Wall-mounted, Portable, Window)</td>
          <td>1 Fancoil Unit - $45.00<br />2 Fancoil Units - $60.00<br />3 Fancoil Units - $75.00</td>
        </tr>
        <tr>
          <td>Aircon Normal Servicing<br />(Ceiling Cassette, Ceiling Suspend, Ceiling Ducted)</td>
          <td>1 Fancoil Unit - $60.00<br />2 Fancoil Units - $90.00<br />3 Fancoil Units - $120.00</td>
        </tr>
      </table>
      <br />
      <table className="rate-table">
        <tr>
          <th>Add-on Services</th>
          <th>Price</th>
        </tr>
        <tr>
          <td>Chemical Wash<br />(Wall-mounted, Portable, Window)</td>
          <td>$90 per unit</td>
        </tr>
        <tr>
          <td>Chemical Wash<br />(Ceiling Cassette, Ceiling Suspend, Ceiling Ducted)</td>
          <td>$180 per unit</td>
        </tr>
        <tr>
          <td>Chemical Overhaul (Small)<br />Typically used in bedrooms (&lt;22K BTU)<br />(Wall-mounted, Portable, Window)</td>
          <td>$160 per unit</td>
        </tr>
        <tr>
          <td>Chemical Overhaul (Big)<br />Typically used in sitting rooms (22K-24K BTU) (Wall-mounted, Portable, Window)</td>
          <td>$180 per unit</td>
        </tr>
        <tr>
          <td>Gas Top Up (Small)</td>
          <td>$120</td>
        </tr>
        <tr>
          <td>Gas Top Up (Large)</td>
          <td>$160</td>
        </tr>
      </table>
      <br />
      <hr />
    </>
  )
}

export function OurServicesDetails_AirconWhyChooseUs() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Why Choose Whissh Aircon Servicing Services?</h2>
          </div>
        </Col>
      </Row>
      <Row style={{ textAlign: 'center' }}>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>High Quality Solutions Used</h3>
          <div class="description">Choosing Whissh Aircon Servicing Services in Singapore ensures you receive the best aircon servicing available. Our eco-friendly solutions are safe for both human health and the aircon coils, making us a top choice for aircon servicing Singapore.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Digital Tracking System</h3>
          <div class="description">Our experienced technicians stay updated with the latest industry knowledge, ensuring high-quality service. With our digital tracking system, we recommend the most suitable service for each aircon unit.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Workmanship Warranty</h3>
          <div class="description">Plus, we offer a workmanship warranty, provided customers follow our technicians’ recommended services. Trust Whissh for reliable and efficient aircon servicing that prioritizes your health and satisfaction.</div>
        </Col>
      </Row>
      <br />
      <hr />
    </>
  )
}

export function OurServicesDetails_DCWhyChooseUs() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Why Choose Whissh Deep Cleaning Services?</h2>
          </div>
        </Col>
      </Row>
      <Row style={{ textAlign: 'center' }}>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Eco-Friendly</h3>
          <div class="description">Choosing Whissh Deep Cleaning Services in Singapore ensures you receive the best deep cleaning services Singapore has to offer. We use EU-Ecolabel certified cleaning solutions, making our services both effective and eco-friendly.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>One-Stop Service Provider</h3>
          <div class="description">As a one-stop service provider, we cater to all your needs, from curtain cleaning to aircon servicing and weekly housekeeping, eliminating the hassle of finding multiple service providers. Trust us for professional cleaning services Singapore residents rely on.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Quality Assurance Programme</h3>
          <div class="description">Our quality assurance program ensures that customer feedback is promptly addressed, with any issues rectified before the service concludes. Experience the convenience and reliability of our professional cleaners Singapore. Choose Whissh for a professional cleaner, cleaning house services today.</div>
        </Col>
      </Row>
      <br />
      <hr />
    </>
  )
}

export function OurServiceDetails_DCHowitworks() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">How our Deep Cleaning Services Work?</h2>
            <p class="description text-center">When you schedule a deep cleaning service with us, you can expect a seamless process.</p>
          </div>
        </Col>
      </Row>
      <Row style={{ textAlign: 'center' }}>
        <Col md="4">
          <i class="fa fa-laptop fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Step 1 - Book Online</h3>
          <div class="description">Book online and receive a confirmation email once your booking is confirmed. Select the date and time of your choice, and include any requests in your booking. Our Customer Service Team will reach out as required.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-mobile fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Step 2 – Reminder SMS</h3>
          <div class="description">A reminder SMS will be sent to you the day before your service.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-thumbs-up fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Step 3 – Return to a Cleaned Property</h3>
          <div class="description">Our professional cleaners Singapore will handle everything, so you do not need to present throughout the session. Upon returning, you’ll find a thoroughly cleaned property. Experience the best deep cleaning services Singapore has to offer with our reliable and efficient professional cleaning services Singapore. Trust our professional cleaner team for all your cleaning house needs.</div>
        </Col>
      </Row>
      <br />
      <hr />
    </>
  )
}

export function OurServiceDetails_AirconTestimonial() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Your Testimonials</h2>
          </div>
        </Col>
      </Row>
      <div class="home_testimonial-container">
        <div class="home_testimonial">
          <p class="testimonial_client-name">A Loyal Customer</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"I engaged Whissh team for aircon servicing. Their service team arrived ahead of the appointment time, was thorough in their job and provided good advice to me on how to keep my aircon in good working condition. Overall, their service is very professional."</p>
        </div>
        <div class="home_testimonial">
          <p class="testimonial_client-name">Happy Customer</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"Engaged Whissh for Aircon servicing - chemical overhaul for our 3 units. Great service by both the technician and customer support. Happy with the serviced air-cons. They also use eco-friendly solutions, which is a plus!"</p>
        </div>
        <div class="home_testimonial">
          <p class="testimonial_client-name">A First-time Customer</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"The service provided by Whissh included:</p>
          <p style={{ fontSize: "0.8em" }}>1. Deep Cleaning of the apartment</p>
          <p style={{ fontSize: "0.8em" }}>2. Aircon servicing</p>
          <p style={{ fontSize: "0.8em" }}>3. Deep cleaning of the curtains</p>
          <p style={{ fontSize: "0.8em" }}>The experience was efficient & effective! Kudos goes to Apple who was very responsive patient & effective in carrying out her job. Thank you! We also want to single out the indian lady that did a first class job in deep cleaning of the apartment for handling taking over!"</p>
        </div>
      </div>
      <br />
      <hr />
    </>
  )
}

export function OurServiceDetails_DCTestimonial() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Your Testimonials</h2>
          </div>
        </Col>
      </Row>
      <div class="home_testimonial-container">
        <div class="home_testimonial">
          <p class="testimonial_client-name">A Concerned Cat Owner</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"I got the spring cleaning package and the cleaners were very thorough and detailed and my place looks good as new! They even vacuumed all of my cat’s soft furnishings and took care when cleaning the windows to make sure my cat’s safely in the room which I really appreciated. I highly recommend it!"</p>
        </div>
        <div class="home_testimonial">
          <p class="testimonial_client-name">First Time Customer</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"Cleaning crew are punctual for spring cleaning. The job is done superbly well and I like that their cleaning products are eco-friendly. Highly recommended."</p>
        </div>
        <div class="home_testimonial">
          <p class="testimonial_client-name">A Busy Professional</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"The ladies were punctual and they were very thorough in their service. Their standard of cleanliness exceeded my rental agent expectations, who had seen a lot of post rental cleaning. I was able to handover my rental place without remarks on cleanliness. Will definitely engage them again."</p>
        </div>
      </div>
      <br />
      <hr />
    </>
  )
}

export function OurServiceDetails_OCTestimonial() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Your Testimonials</h2>
          </div>
        </Col>
      </Row>
      <div class="home_testimonial-container">
        <div class="home_testimonial">
          <p class="testimonial_client-name">SAS Asia Bar Systems</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"Our company have been using "1 Plus Private Limited a.k.a. Whissh.com" for our office cleaning services since Year 2022. We are extremely satisfied with the crews they have appointed to our office cleaning with high professional standard, and we are totally satisfied with their services. The crews are punctuality, attention to detail and made sure all handled with care without any instruction given to them. The customer service team also provide their timely respond to any queries and in need of assistance. We are highly recommended 1 Plus Private Limited to anyone looking for office cleaning services!"</p>
        </div>
        <div class="home_testimonial">
          <p class="testimonial_client-name">Heraeus Asia Pacific Holding Pte Ltd</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"I recently had the pleasure of engaging the cleaning services of 1 Plus Private Limited a. k. a Whissh.com, and I must say, the experience was exceptional from start to finish. Not only was the cleaning thorough and impeccable, but the level of customer service I received was truly outstanding. The staff were courteous, attentive, and went above and beyond to ensure that all my needs were met. I was impressed by their professionalism and dedication to customer satisfaction. The friendly and knowledgeable customer service team made the entire process seamless and stress-free. I highly recommend 1 Plus Private Limited a. k. a Whissh.com to anyone looking for a cleaning service that delivers top-notch results with a personal touch. The detailed focus on the outstanding customer service experience will surely leave a positive impression on the cleaning service company and its potential clients."</p>
        </div>
        <div class="home_testimonial">
          <p class="testimonial_client-name">United Nations Development Programme</p>
          <div class="home_stars">★★★★★</div>
          <p style={{ fontSize: "0.8em" }}>"We are delighted to share our positive experience working with Whissh Singapore for their outstanding cleaning services. Whissh has consistently delivered high standards of cleanliness and reliability, ensuring our workspace is always well-maintained.<br /><br />
            In addition to their regular cleaning services, Whissh has provided prompt and efficient support for our ad-hoc events that required additional cleaning. Their quick response and flexibility have been invaluable in helping us manage events smoothly.<br /><br />
            We would also like to commend the cleaner assigned to our office, who has been incredibly friendly and professional. Their positive attitude and willingness to go the extra mile have made them a pleasure to work with and have fostered a welcoming atmosphere within our team.<br /><br />
            Whissh Singapore has proven to be a trusted and dependable partner, and we highly recommend their services to any organization in need of reliable and quality cleaning."</p>
        </div>
      </div>
      <br />
      <hr />
    </>
  )
}

export function OurServicesDetails_OCWhyChooseUs() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Why Choose Whissh Office Cleaning Services?</h2>
            <p class="description text-center pb-30">Whissh Office Cleaning Services stands out as the ideal choice for businesses seeking a reliable, eco-conscious, and comprehensive cleaning solution in Singapore. We offer a unique blend of expertise and commitment, setting us apart from the competition.</p>
          </div>
        </Col>
      </Row>
      <Row style={{ textAlign: 'center' }}>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Unwavering Commitment to Quality</h3>
          <div class="description">NEA Class 1 License: Our commitment to excellence is reflected in our NEA Class 1 License, ensuring we meet the highest standards of hygiene and safety. This guarantees a clean and healthy environment for your employees and clients.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Eco-Friendly Solutions for a Sustainable Future</h3>
          <div class="description">EU-Ecolabel Certified Products: We prioritize sustainability by utilizing EU-Ecolabel certified cleaning solutions, minimizing our environmental impact while maintaining exceptional cleaning results.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>One-Stop Solution for Seamless Property Management</h3>
          <div class="description">Comprehensive Service Provider: Whissh is more than just a cleaning service. We offer a one-stop solution for all your property needs, from cleaning to maintenance, ensuring a hassle-free experience.</div>
        </Col>
      </Row>
      <Col md="12">
        <div className="mt-20">
          <p class="description text-center pb-30">Choose Whissh Office Cleaning Services for a clean, sustainable, and efficient workspace. We provide a superior cleaning experience that exceeds your expectations.</p>
        </div>
      </Col>
      <br />
      <hr />
    </>
  )
}

export function OurServiceDetails_AirconProcess() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Our Aircon Servicing Process</h2>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <p class="description">Whissh is committed to delivering the best aircon servicing in Singapore. Our comprehensive aircon servicing services include:</p>
          <b>1. Inspection</b>
          <ul>
            <li class="description">Visual inspection of aircon unit, including cover, air filter, and front panel.</li>
            <li class="description">Assessment of overall condition and potential issues.</li>
          </ul>
          <b>2. Cleaning & Maintenance</b>
          <ul>
            <li class="description">Thorough cleaning of air filter, front panel, and indoor drainage tray.</li>
            <li class="description">Purification and deodorisation of air filter.</li>
            <li class="description">Cleaning and inspection of indoor evaporator coil.</li>
            <li class="description">Lubrication of fan and bearing (if required).</li>
          </ul>
          <b>3. Performance Check</b>
          <ul>
            <li class="description">Checking of discharge pressure and compressor suction for optimal performance.</li>
            <li class="description">Vacuuming of drainage system to prevent blockages.</li>
          </ul>
          <b>4. Recommendations</b>
          <ul>
            <li class="description">Expert advice on additional services required, such as chemical washing or gas top-up.</li>
          </ul>
          <b>5. Digital Service Report</b>
          <ul>
            <li class="description">Comprehensive report detailing the service performed and any recommendations, delivered digitally for your convenience.</li>
          </ul>
        </Col>
      </Row>
      <br />
      <hr />
    </>
  )
}

export function OurServicesDetails_OfficeDCWhyChooseUs() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Why Choose Whissh Commercial Deep Cleaning Services?</h2>
          </div>
        </Col>
      </Row>
      <Row style={{ textAlign: 'center' }}>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Eco-Friendly</h3>
          <div class="description">Whissh tries as much as possible to use EU-Ecolabel certified cleaning solutions during our Deep Cleaning Services. Depending on the services required, industrial-grade solutions might also be deployed.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>One-Stop Service Provider</h3>
          <div class="description">As a one-stop service provider, Whissh works to cater to all your needs. Choose Whissh for convenience as the one-stop service provider, from your deep cleaning needs to your aircon maintenance needs, as well as your carpet shampooing services.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Quality Assurance Programme</h3>
          <div class="description">Our in-house digital tracking system ensures that feedback is tracked and taken seriously. Alongside our quality assurance programme, we ensure that issues are rectified as quickly as possible.</div>
        </Col>
      </Row>
      <br />
      <hr />
    </>
  )
}

export function OurServicesDetails_OfficeAirconWhyChooseUs() {
  return (
    <>
      <Row>
        <Col md="12">
          <div className="mt-20">
            <h2 className="title-2 text-center">Why Choose Whissh Commercial Aircon Servicing?</h2>
          </div>
        </Col>
      </Row>
      <Row style={{ textAlign: 'center' }}>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>High Quality Solutions Used</h3>
          <div class="description">Choosing Whissh Aircon Servicing Services in Singapore ensures you receive the best aircon servicing available. Our eco-friendly solutions are safe for both human health and the aircon coils, making us a top choice for aircon servicing Singapore.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Digital Tracking System</h3>
          <div class="description">Our experienced technicians stay updated with the latest industry knowledge, ensuring high-quality service. With our digital tracking system, we recommend the most suitable service for each aircon unit.</div>
        </Col>
        <Col md="4">
          <i class="fa fa-star fa-2x" aria-hidden="true" style={{ color: "#404e58e0" }}></i>
          <h3 class="title-3" style={{ marginBottom: "0", paddingTop: "10px", paddingBottom: "10px" }}>Workmanship Warranty</h3>
          <div class="description">Plus, we offer a workmanship warranty, provided customers follow our technicians’ recommended services. Trust Whissh for reliable and efficient aircon servicing that prioritizes your health and satisfaction.</div>
        </Col>
      </Row>
      <br />
      <hr />
    </>
  )
}
